import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { VerificationRequiredGuard } from './pages/login/verification-required.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { 
    path: 'details', 
    loadChildren: () => import('./pages/driver-details/driver-details.module').then(m => m.DriverDetailsModule), 
    canActivate: [() => inject(VerificationRequiredGuard).canActivate()] 
  },
  { path: 'signup', loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterModule) },
  { path: 'password', loadChildren: () => import('./pages/login/forgotten-password/forgotten-password.module').then(m => m.ForgottenPasswordModule) },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', component: LoginComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
